export const SHOW_TOAST = 'SHOW_TOAST'
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'
export const SHOW_SUCCESS = 'SHOW_SUCCESS'
export const HIDE_SUCCESS = 'HIDE_SUCCESS'
export const SHOW_ERROR = 'SHOW_ERROR'
export const HIDE_ERROR = 'HIDE_ERROR'

export enum PALETTE_COLOR {
  LIGHT_GRAY = '#C8C8C8', // gray text
  VERY_LIGHT_GRAY = '#9ba0a4', // heart and muscle icon color
  VERY_LIGHT_GRAY_2 = '#E6E6E6', // ボタンの塗りとか
  VERY_LIGHT_GRAY_3 = '#F5F5F5', // セクション見出しの塗り
  VERY_LIGHT_GRAY_4 = '#f8f8f8', // 薄いグレー背景とか
  VERY_LIGHT_GRAY_5 = '#f0f0f0', // 微妙なボーダーラインとか
  DARK_GRAY = '#969696',
  VERY_DARK_GRAY = '#5a5a5a', // thin text color
  BLACK = '#282828', // base black text
  WHITE = '#ffffff',
  PINK = '#D683C6',
  STRONG_GREEN = '#4cd964',
  STRONG_RED = '#ed5c43',
  BG_GRADIENT_0 = 'linear-gradient(to top, #f3f4f6, #f3f4f6 1%, #fcfcfc 41%, #ffffff 100%)',
}

export enum STATUS_COLOR {
  STATUS_BORDER = 'rgba(0, 0, 0, 0.15)',
  STATUS_0 = '#3c3c3c', // -
  STATUS_1 = '#ed5c43', // x
  STATUS_2 = '#eab900', // △
  STATUS_3 = '#50af8d', // ◯
  STATUS_4 = '#03b4dd', // ◎
}

export enum FONT {
  XXLARGE = 30,
  XLARGE = 22,
  LARGE = 18,
  MIDDLE2 = 16,
  MIDDLE1 = 15,
  MIDDLE = 14,
  BASE2 = 13,
  BASE = 12,
  SMALL = 11,
  XSMALL = 10,
}

export enum BRAND {
  PRIMARY = PALETTE_COLOR.STRONG_GREEN,
  SECONDARY = STATUS_COLOR.STATUS_3,
  DANGER = STATUS_COLOR.STATUS_1,
}

export enum FONT_WEIGHT {
  THIN = 300,
  NORMAL = 400,
  BOLD = 600,
}

export const Color = {
  PALETTE_COLOR,
  ...PALETTE_COLOR,
  ...STATUS_COLOR,
  STATUS_COLOR,
  BRAND,
}

export const Size = {
  ...FONT,
  FONT,
  FONT_WEIGHT,
  BREAK_POINT: {
    PC: 750,
    MOBILE: 365,
  },
}



// WEBPACK FOOTER //
// ./src/constants/app.constant.ts